import { Routes, Route, Navigate } from 'react-router-dom';
import { ROUTES } from 'lib/constants';
import { ProtectedRoute } from 'routes/ProtectedRoute';
import { PublicRoute } from 'routes/PublicRoute';
import { DashboardLayout } from 'components/layout';
import { VendorProvider } from 'features/vendor';
import { LoginPage } from 'features/auth';
import { DashboardHome } from 'features/dashboard';
import { CatalogPage, AddProductPage, EditProductPage } from 'features/catalog';
import { OrdersPage } from 'features/orders';
import { RecordSalePage } from 'features/instore';
import { InventoryAdjustmentPage } from 'features/inventory';
import { EarningsPage } from 'features/earnings';
import { ShopProfilePage } from 'features/shop';
import { StaffPage } from 'features/staff';
import { BankAccountsPage } from 'features/bank';

/** Top-level route table: public login + protected dashboard shell. */
export function AppRoutes() {
  return (
    <Routes>
      <Route element={<PublicRoute />}>
        <Route path={ROUTES.LOGIN} element={<LoginPage />} />
      </Route>

      <Route element={<ProtectedRoute />}>
        <Route
          element={
            <VendorProvider>
              <DashboardLayout />
            </VendorProvider>
          }
        >
          <Route path={ROUTES.DASHBOARD} element={<DashboardHome />} />
          <Route path={ROUTES.CATALOG} element={<CatalogPage />} />
          <Route path={ROUTES.CATALOG_ADD} element={<AddProductPage />} />
          <Route path={ROUTES.CATALOG_EDIT} element={<EditProductPage />} />
          <Route path={ROUTES.ORDERS} element={<OrdersPage />} />
          <Route path={ROUTES.INSTORE_SALE} element={<RecordSalePage />} />
          <Route path={ROUTES.INVENTORY} element={<InventoryAdjustmentPage />} />
          <Route path={ROUTES.EARNINGS} element={<EarningsPage />} />
          <Route path={ROUTES.SHOP} element={<ShopProfilePage />} />
          <Route path={ROUTES.STAFF} element={<StaffPage />} />
          <Route path={ROUTES.BANK} element={<BankAccountsPage />} />
        </Route>
      </Route>

      <Route path="*" element={<Navigate to={ROUTES.DASHBOARD} replace />} />
    </Routes>
  );
}

export default AppRoutes;
